<template>
  <div>
    <NewNavBar />
    <div class="newUserLayout-container" :class="{ 'newUserLayout-mobile-container': isMobile }">
      <!-- 主内容布局 -->
      <div class="newUserLayout-content-wrapper" :class="{ 'newUserLayout-mobile-content-wrapper': isMobile }">
        <!-- 左侧菜单 - 移动端改为抽屉式 -->
        <div v-if="!isMobile" class="newUserLayout-menu-container">
          <div class="newUserLayout-custom-menu">
            <img style="cursor: pointer; height: 60px; margin-bottom: 10px" src="@/assets/images/吉祥物.png" @click="linkTo('new-index2')">
            <template v-for="menu in menuConfig">
              <div v-if="menu.children && menu.children.length > 0" :key="menu.id" class="newUserLayout-menu-section">
                <div
                  :class="['newUserLayout-menu-item newUserLayout-primary', { 'newUserLayout-active': isPrimaryActive(menu) }]"
                  @click="toggleSection(menu.id)"
                >
                  <img class="newUserLayout-menu-icon" v-if="menu.icon" width="25px" :src="menu.icon"/>
                  <span class="newUserLayout-menu-label">{{ menu.label }}</span>
                  <span class="newUserLayout-menu-arrow">{{ sectionStates[menu.id] ? '▼' : '▶' }}</span>
                </div>
                <div v-if="sectionStates[menu.id]" class="newUserLayout-submenu-container">
                  <div
                    v-for="sub in menu.children"
                    :key="sub.id"
                    :class="['newUserLayout-submenu-item', { 'newUserLayout-active': isSubMenuActive(sub.value) }]"
                    @click="handleMenuClick(sub)"
                  >
                    <img class="newUserLayout-submenu-icon" v-if="sub.icon" width="25px" :src="sub.icon"/>
                    <span class="newUserLayout-submenu-label">{{ sub.label }}</span>
                  </div>
                </div>
              </div>
              <div
                v-else
                :key="menu.id"
                :class="['newUserLayout-menu-item newUserLayout-direct', { 'newUserLayout-active': isDirectMenuActive(menu.value) }]"
                @click="handleMenuClick(menu)"
              >
                <img class="newUserLayout-menu-icon" v-if="menu.icon" width="25px" :src="menu.icon"/>
                <span class="newUserLayout-menu-label">{{ menu.label }}</span>
              </div>
            </template>
          </div>
        </div>

        <!-- 移动端菜单按钮和抽屉 -->
        <div v-if="isMobile" class="newUserLayout-mobile-menu-header">
          <div class="newUserLayout-mobile-menu-trigger" @click="toggleMobileMenu">
            <i class="el-icon-menu"></i>
            <span>菜单</span>
          </div>
          <div class="newUserLayout-mobile-logo" @click="linkTo('new-index2')">
            <img src="@/assets/images/吉祥物.png" style="height: 40px">
          </div>
        </div>

        <!-- 移动端抽屉菜单 -->
        <transition name="newUserLayout-drawer-fade">
          <div v-if="isMobile && mobileMenuVisible" class="newUserLayout-mobile-drawer-overlay" @click="toggleMobileMenu">
            <div class="newUserLayout-mobile-drawer" @click.stop>
              <div class="newUserLayout-drawer-header">
                <img src="@/assets/images/吉祥物.png" style="height: 50px">
                <i class="el-icon-close" @click="toggleMobileMenu"></i>
              </div>
              <div class="newUserLayout-drawer-menu">
                <template v-for="menu in menuConfig">
                  <div v-if="menu.children && menu.children.length > 0" :key="menu.id" class="newUserLayout-drawer-menu-section">
                    <div
                      :class="['newUserLayout-drawer-menu-item', { 'newUserLayout-active': isPrimaryActive(menu) }]"
                      @click="toggleMobileSection(menu.id)"
                    >
                      <img class="newUserLayout-menu-icon" v-if="menu.icon" width="25px" :src="menu.icon"/>
                      <span class="newUserLayout-menu-label">{{ menu.label }}</span>
                      <span class="newUserLayout-menu-arrow">{{ mobileSectionStates[menu.id] ? '▼' : '▶' }}</span>
                    </div>
                    <div v-if="mobileSectionStates[menu.id]" class="newUserLayout-drawer-submenu">
                      <div
                        v-for="sub in menu.children"
                        :key="sub.id"
                        :class="['newUserLayout-drawer-submenu-item', { 'newUserLayout-active': isSubMenuActive(sub.value) }]"
                        @click="handleMobileMenuClick(sub)"
                      >
                        <span class="newUserLayout-submenu-label">{{ sub.label }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    :key="menu.id"
                    :class="['newUserLayout-drawer-menu-item newUserLayout-direct', { 'newUserLayout-active': isDirectMenuActive(menu.value) }]"
                    @click="handleMobileMenuClick(menu)"
                  >
                    <img class="newUserLayout-menu-icon" v-if="menu.icon" width="25px" :src="menu.icon"/>
                    <span class="newUserLayout-menu-label">{{ menu.label }}</span>
                  </div>
                </template>
              </div>
              <div class="newUserLayout-drawer-footer">
                <div class="newUserLayout-drawer-user-info">
                  <i class="el-icon-user"></i>
                  <span>{{ getPhone(true) }}</span>
                </div>
                <div class="newUserLayout-drawer-logout" @click="loginOut">
                  <i class="el-icon-switch-button"></i>
                  <span>退出登录</span>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <!-- 右侧内容区 -->
        <div class="newUserLayout-content-container" :class="{ 'newUserLayout-mobile-content-container': isMobile }">
          <!-- 移动端搜索区域独立出来 -->
          <div class="newUserLayout-search" :class="{ 'newUserLayout-mobile-search-U': isMobile }">
            <div class="newUserLayout-search-wrapper" :class="{ 'newUserLayout-mobile-search-wrapper': isMobile }">
              <el-input
                v-model="keyword"
                class="newUserLayout-search-input"
                :class="{ 'newUserLayout-mobile-search-input-U': isMobile }"
                @keydown.enter.native="handleSearch"
                @focus="handleFocus"
                @blur="handleBlur"
                placeholder="请输入搜索内容"
              >
                <i slot="prefix" class="el-icon-search" :style="isMobile ? 'line-height: 35px; color: #6a6a6a; margin-left: 8px;' : 'line-height: 47px; color: #6a6a6a; margin-left: 8px;'"></i>
                <el-button
                  slot="suffix"
                  class="newUserLayout-search-input-button1"
                  :class="{ 'newUserLayout-mobile-search-btn': isMobile }"
                  @click="handleSearch"
                >
                  搜索
                </el-button>
              </el-input>

              <!-- 历史记录下拉框 - 调整位置和层级 -->
              <div
                class="newUserLayout-history-dropdown"
                :class="{ 'newUserLayout-mobile-history-dropdown': isMobile }"
                v-if="showHistory && historyList.length > 0"
              >
                <div class="newUserLayout-history-header">
                  <span class="newUserLayout-history-title">历史搜索</span>
                  <span class="newUserLayout-history-clear" @click.stop="clearHistory">清空</span>
                </div>
                <div class="newUserLayout-history-list">
                  <div
                    v-for="(item, index) in historyList"
                    :key="index"
                    class="newUserLayout-history-item"
                    @click.stop="searchHistoryItem(item)"
                  >
                    <i class="el-icon-time"></i>
                    <span class="newUserLayout-history-text">{{ item }}</span>
                    <i class="el-icon-close newUserLayout-history-delete" @click.stop="removeHistoryItem(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhone } from '@/utils/auth'
import { isMember, isMemberAdmin } from '@/api/member'
import NewNavBar from '@/layouts/NewNavBar.vue'
import { client_logout } from '@/utils/login'

export default {
  name: 'UserLayout',
  components: { NewNavBar },
  data() {
    return {
      keyword: '',
      historyList: [],
      showHistory: false,
      STORAGE_KEY: 'search_history',
      MAX_HISTORY: 10,
      isMobile: false,
      mobileMenuVisible: false,
      mobileSectionStates: {},
      blurTimer: null,
      menuConfig: [
        {
          id: 'personal',
          label: '个人中心',
          value: '/newUser/personalCenter',
          icon: require("../../static/svg/个人中心.svg"),
        },
        {
          id: 'order',
          label: '订单中心',
          icon: require("../../static/svg/订单中心.svg"),
          children: [
            { id: 'order-my', label: '我的订单', value: '/newUser/orders', icon: '' },
            { id: 'courier-record', label: '邮寄记录', value: '/newUser/courier-record', icon: '' },
            { id: 'courier-record', label: '回收记录', value: '/newUser/recycle-record', icon: '' },
            { id: 'appraise-new', label: '订单评价', value: '/newUser/appraise-new', icon: '' },
          ]
        },
        {
          id: 'member',
          label: '会员中心',
          icon: require("../../static/svg/会员中心.svg"),
          children: [
            { id: 'member-info', label: '我的会员', value: '/newUser/member', icon: '' },
            { id: 'member-auth', label: '账户授权', value: '/newUser/account-auth', icon: '' },
          ]
        },
        {
          id: 'account',
          label: '账户设置',
          icon: require("../../static/svg/账户设置.svg"),
          children: [
            { id: 'entrust-info', label: '委托信息', value: '/newUser/entrustInfo', icon: '' },
            { id: 'member-points', label: '我的积分', value: '/newUser/my-points', icon: '' },
            { id: 'account-address', label: '寄样地址', value: '/newUser/receivingAddress', icon: '' },
            { id: 'my-coupon', label: '优惠卡券', value: '/newUser/myCoupon', icon: '' }
          ]
        }
      ],
      sectionStates: {},
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path
    }
  },
  methods: {
    getPhone,
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
      if (this.mobileMenuVisible) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    toggleMobileSection(sectionId) {
      this.$set(this.mobileSectionStates, sectionId, !this.mobileSectionStates[sectionId])
    },
    handleMobileMenuClick(menu) {
      this.mobileMenuVisible = false
      document.body.style.overflow = ''
      if (menu.value) {
        this.$router.push(menu.value)
      }
    },
    isDirectMenuActive(menuValue) {
      return this.currentRoutePath.includes(menuValue)
    },
    isPrimaryActive(menu) {
      if (menu.children && menu.children.length > 0) {
        return menu.children.some(sub => this.isSubMenuActive(sub.value))
      }
      return false
    },
    isSubMenuActive(subMenuValue) {
      return this.currentRoutePath.includes(subMenuValue)
    },
    initSectionStates() {
      const states = {}
      this.menuConfig.forEach(menu => {
        if (menu.children && menu.children.length > 0) {
          states[menu.id] = true
        }
      })
      this.sectionStates = states
      this.mobileSectionStates = { ...states }
    },
    toggleSection(sectionId) {
      this.$set(this.sectionStates, sectionId, !this.sectionStates[sectionId])
    },
    handleMenuClick(menu) {
      if (menu.value) {
        this.$router.push(menu.value)
      }
    },
    loginOut() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        client_logout()
      }).catch(() => {
      })
    },
    // 历史搜索相关方法
    loadHistory() {
      const history = localStorage.getItem(this.STORAGE_KEY)
      if (history) {
        this.historyList = JSON.parse(history)
      } else {
        this.historyList = []
      }
    },
    saveHistory(keyword) {
      if (!keyword || keyword.trim() === '') return
      let newList = [keyword, ...this.historyList.filter(item => item !== keyword)]
      if (newList.length > this.MAX_HISTORY) {
        newList = newList.slice(0, this.MAX_HISTORY)
      }
      this.historyList = newList
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newList))
    },
    removeHistoryItem(index) {
      this.historyList.splice(index, 1)
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.historyList))
      if (event) event.stopPropagation()
    },
    clearHistory() {
      this.historyList = []
      localStorage.removeItem(this.STORAGE_KEY)
      this.showHistory = false
    },
    searchHistoryItem(item) {
      this.keyword = item
      this.showHistory = false
      this.handleSearch()
    },
    handleClickOutside(e) {
      const searchEl = document.querySelector('.newUserLayout-search-wrapper')
      if (searchEl && !searchEl.contains(e.target)) {
        this.showHistory = false
      }
    },
    handleFocus() {
      if (this.historyList.length > 0) {
        this.showHistory = true
      }
    },
    handleBlur() {
      // 延迟关闭，让点击历史记录项能够执行
      this.blurTimer = setTimeout(() => {
        this.showHistory = false
      }, 200)
    },
    handleSearch() {
      if (this.blurTimer) {
        clearTimeout(this.blurTimer)
      }
      if (this.keyword && this.keyword.trim() !== '') {
        this.saveHistory(this.keyword.trim())
      }
      this.showHistory = false
      this.linkToNewTab('select-page', {}, { searchInfo: this.keyword })
    },
    judgeIsMemberAdmin() {
      isMemberAdmin().then(adminRes => {
        if (adminRes.code === 200 && adminRes.data === false) {
          let newMenuConfig = JSON.parse(JSON.stringify(this.menuConfig))
          for (let i = 0; i < newMenuConfig.length; i++) {
            const menu = newMenuConfig[i]
            if (menu.id === 'member' && menu.children && menu.children.length > 0) {
              const filteredChildren = []
              for (let j = 0; j < menu.children.length; j++) {
                if (menu.children[j].value !== '/newUser/account-auth') {
                  filteredChildren.push(menu.children[j])
                }
              }
              menu.children = filteredChildren
            }
          }
          this.menuConfig = newMenuConfig
        }
      }).catch(error => {
        console.error('管理员权限检查失败:', error)
      })

      isMember().then(memberRes => {
        if (memberRes.code === 200 && memberRes.data === false) {
          let newMenuConfig = JSON.parse(JSON.stringify(this.menuConfig))
          const filteredMenu = []
          for (let i = 0; i < newMenuConfig.length; i++) {
            if (newMenuConfig[i].id !== 'member') {
              filteredMenu.push(newMenuConfig[i])
            }
          }
          this.menuConfig = filteredMenu
          this.$nextTick(() => {
            this.initSectionStates()
          })
        }
      }).catch(error => {
        console.error('会员权限检查失败:', error)
      })
    },
    linkTo(name, params, query) {
      if (query) {
        this.$router.push({ name, params, query })
      } else if (params) {
        this.$router.push({ name, params })
      } else {
        this.$router.push({ name })
      }
    },
    linkToNewTab(name, params, query) {
      const routeData = this.$router.resolve({
        name,
        params,
        query
      })
      window.open(routeData.href, '_blank')
    }
  },
  created() {
    this.checkMobile()
    this.initSectionStates()
    this.judgeIsMemberAdmin()
    window.addEventListener('resize', this.checkMobile)
  },
  mounted() {
    this.loadHistory()
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('resize', this.checkMobile)
    if (this.blurTimer) {
      clearTimeout(this.blurTimer)
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  box-sizing: border-box;
}

.newUserLayout-container {
  padding-top: 10px;
  min-height: calc(100vh - 80px);
}

.newUserLayout-content-wrapper {
  display: flex;
  width: 1620px;
  margin: 0 auto;
  gap: 20px;
}

/* —————— 左侧菜单 —————— */
.newUserLayout-menu-container {
  width: 170px;
  flex-shrink: 0;
}

.newUserLayout-custom-menu {
  border-radius: 8px;
  overflow: hidden;
}

.newUserLayout-menu-section {
  margin-bottom: 4px;
}

.newUserLayout-menu-item {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  color: #4a5568;

  &.newUserLayout-primary {
    font-weight: 500;

    &:hover {
      background-color: #fff0f0;
      color: #ff4444;
    }

    &.newUserLayout-active {
      color: #ff4444;

      .newUserLayout-menu-icon svg {
        fill: #ff4444;
      }
    }
  }

  &.newUserLayout-direct {
    &:hover {
      background-color: #fff0f0;
      color: #ff4444;
    }

    &.newUserLayout-active {
      background-color: #ffeaea;
      color: #ff4444;
      font-weight: 500;

      .newUserLayout-menu-icon svg {
        fill: #ff4444;
      }
    }
  }
}

.newUserLayout-menu-icon {
  display: flex;
  align-items: center;
  margin-right: 12px;
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
}

.newUserLayout-menu-label {
  flex: 1;
  font-size: 14px;
  line-height: 1;
}

.newUserLayout-menu-arrow {
  font-size: 12px;
  color: #999;
  margin-left: 8px;
}

.newUserLayout-submenu-container {
  border-top: 1px solid #f0f0f0;
}

.newUserLayout-submenu-item {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px 0 48px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;
  font-size: 13px;

  &:hover {
    background-color: #fff0f0;
    color: #ff4444;
  }

  &.newUserLayout-active {
    background-color: #ffeaea;
    color: #ff4444;
    font-weight: 500;
  }
}

/* —————— 右侧内容区 —————— */
.newUserLayout-content-container {
  background: #ffffff;
  border-radius: 8px;
  min-height: 600px;
  padding: 24px;
  width: 1400px;
  margin: 0 auto;
}

.newUserLayout-search {
  position: relative;
  text-align: right;
  margin-bottom: 20px;
}

.newUserLayout-search-wrapper {
  position: relative;
  display: inline-block;
  width: 23%;
  min-width: 280px;
}

.newUserLayout-search-input {
  width: 100%;
}

/deep/ .newUserLayout-search-input .el-input__inner {
  height: 45px;
  border: 2px solid #ff4444;
  border-radius: 4px;
  padding-left: 30px;
  padding-right: 65px;
}

.newUserLayout-search-input-button1 {
  background: #ff4444;
  color: white;
  height: 33px;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  margin-top: 5px;
  margin-right: 4px;

  &:hover{
    background: #ef0000;
    color: white;
  }
  &:focus{
    background: #f10000;
    color: white;
  }
  &:active{
    background: #ef0000;
    color: white;
    border-color: #ef0000;
  }
}

/* 历史搜索下拉框 - 修复移动端遮挡问题 */
.newUserLayout-history-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ff4444;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
}

.newUserLayout-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.newUserLayout-history-title {
  font-weight: 500;
  color: #333;
}

.newUserLayout-history-clear {
  color: #999;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    color: #ff4444;
  }
}

.newUserLayout-history-list {
  padding: 5px 0;
}

.newUserLayout-history-item {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;

  &:hover {
    background: #f5f5f5;
  }
}

.newUserLayout-history-item .el-icon-time {
  color: #999;
  margin-right: 8px;
  font-size: 14px;
}

.newUserLayout-history-text {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.newUserLayout-history-delete {
  color: #999;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s;
  padding: 4px;
  cursor: pointer;
}

.newUserLayout-history-item:hover .newUserLayout-history-delete {
  opacity: 1;
}

.newUserLayout-history-delete:hover {
  color: #ff4444;
}

/* ========== 移动端样式 ========== */
@media (max-width: 1024px) {
  .newUserLayout-content-wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .newUserLayout-content-container {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .newUserLayout-container {
    padding-top: 0;
  }

  .newUserLayout-content-wrapper {
    flex-direction: column;
    padding: 0 12px;
    gap: 12px;
  }

  .newUserLayout-content-container {
    padding: 16px;
    min-height: calc(100vh - 120px);
  }

  /* 移动端菜单头部 */
  .newUserLayout-mobile-menu-header {
    display: none;
    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    //padding: 12px 0;
    //background: white;
    //top: 60px;
    //z-index: 99;
    //border-bottom: 1px solid #f0f0f0;
  }

  .newUserLayout-mobile-menu-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #ff4444;
    color: white;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;

    i {
      font-size: 18px;
    }
  }

  .newUserLayout-mobile-logo {
    cursor: pointer;

    img {
      height: 36px;
    }
  }

  /* 抽屉菜单遮罩 */
  .newUserLayout-drawer-fade-enter-active,
  .newUserLayout-drawer-fade-leave-active {
    transition: all 0.3s ease;
  }

  .newUserLayout-drawer-fade-enter,
  .newUserLayout-drawer-fade-leave-to {
    opacity: 0;
  }

  .newUserLayout-drawer-fade-enter .newUserLayout-mobile-drawer,
  .newUserLayout-drawer-fade-leave-to .newUserLayout-mobile-drawer {
    transform: translateX(-100%);
  }

  .newUserLayout-mobile-drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1001;
  }

  .newUserLayout-mobile-drawer {
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    height: 100%;
    background: white;
    display: flex;
    flex-direction: column;
    transition: transform 0.3s ease;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }

  .newUserLayout-drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #ff4f4f 100%);
    color: white;

    i {
      font-size: 24px;
      cursor: pointer;
    }
  }

  .newUserLayout-drawer-menu {
    flex: 1;
    overflow-y: auto;
    padding: 10px 0;
  }

  .newUserLayout-drawer-menu-item {
    display: flex;
    align-items: center;
    padding: 14px 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #333;

    &.newUserLayout-active {
      color: #ff4444;

      .newUserLayout-menu-icon svg {
        fill: #ff4444;
      }
    }

    &:active {
      background-color: #f5f5f5;
    }
  }

  .newUserLayout-drawer-submenu {
    background-color: #fafafa;
  }

  .newUserLayout-drawer-submenu-item {
    padding: 12px 20px 12px 52px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #666;
    font-size: 13px;

    &.newUserLayout-active {
      background-color: #ffeaea;
      color: #ff4444;
      font-weight: 500;
    }

    &:active {
      background-color: #f5f5f5;
    }
  }

  .newUserLayout-drawer-footer {
    border-top: 1px solid #f0f0f0;
    padding: 16px 20px;
  }

  .newUserLayout-drawer-user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    color: #666;
    font-size: 14px;

    i {
      font-size: 18px;
      color: #ff4444;
    }
  }

  .newUserLayout-drawer-logout {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    color: #ff4444;
    cursor: pointer;
    font-size: 14px;

    i {
      font-size: 18px;
    }

    &:active {
      opacity: 0.7;
    }
  }

  /* 移动端搜索框 - 修复布局问题 */
  .newUserLayout-mobile-search-U {
    text-align: left;
    margin-bottom: 16px;
  }

  .newUserLayout-mobile-search-wrapper {
    width: 100%;
    min-width: auto;
    display: block;
  }

  .newUserLayout-mobile-search-input-U {
    width: 100% !important;

    /deep/ .el-input__inner {
      -webkit-appearance: none;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 34px;
      line-height: 40px;
      outline: 0;
      padding: 0 30px;
      -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      width: 100%;
    }
  }

  .newUserLayout-mobile-search-btn {
    width: 50px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    margin-top: 2px;
    margin-right: 3px;
  }

  /* 移动端历史记录 - 不遮挡输入框 */
  .newUserLayout-mobile-history-dropdown {
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    max-height: 250px;
    border-radius: 8px;
  }

  .newUserLayout-history-item {
    padding: 10px 12px;

    .newUserLayout-history-delete {
      opacity: 0.6;
      padding: 6px;
    }
  }

  .newUserLayout-history-item:hover .newUserLayout-history-delete {
    opacity: 0.6;
  }
}

/* 小屏手机优化 */
@media (max-width: 480px) {

  .newUserLayout-content-container {
    padding: 12px;
  }

  .newUserLayout-mobile-drawer {
    width: 260px;
  }

  .newUserLayout-drawer-menu-item {
    padding: 12px 16px;
  }

  .newUserLayout-drawer-submenu-item {
    padding: 10px 16px 10px 48px;
  }

  .newUserLayout-drawer-header {
    padding: 16px;

    img {
      height: 40px;
    }
  }

  .newUserLayout-mobile-search-input-U {
    /deep/ .el-input__inner {
      -webkit-appearance: none;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 34px;
      line-height: 40px;
      outline: 0;
      padding: 0 30px;
      -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      width: 100%;
    }
  }

  .newUserLayout-mobile-search-btn {
    width: 45px;
    height: 30px;
    font-size: 12px;
  }

  .newUserLayout-mobile-history-dropdown {
    max-height: 220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/NewUserLayout.vue